import React from "react";

// Helper function to round scores to at most 1 decimal place
const roundScore = (score) => {
  if (typeof score === "number" && !isNaN(score)) {
    return Math.round(score * 10) / 10;
  }
  return score;
};

const TestItem = ({ test, testInd, topic, renderTestButton, focusedExam }) => {
  // Score badge logic (copied from PracticeSetItem.js)
  const score = test?.score;
  const isBand = test?.type && (test?.type === 'writing' || test?.type === 'speaking')
  const isPending = test?.gradingStatus !== 'graded' && (test?.type === 'writing' || test?.type === 'speaking')
  const isUnattempted =
    score === null || score === undefined || isNaN(Number(score));
  let badgeStyle = {
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: 600,
    backgroundColor: "#F3F4F6",
    color: "#6B7280",
    border: "1px solid #E5E7EB",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
  };
  if (!isUnattempted) {
    const numScore = isBand && isPending ? 'Pending' : isBand ? Number((score / 9) * 100) : Number(score);
    if (numScore >= 90) {
      badgeStyle = {
        ...badgeStyle,
        backgroundColor: "#D1FAE5",
        color: "#065F46",
        border: "1px solid #A7F3D0",
      };
    } else if (numScore >= 60) {
      badgeStyle = {
        ...badgeStyle,
        backgroundColor: "#FFF7ED",
        color: "#B45309",
        border: "1px solid #FDBA74",
      };
    } else {
      badgeStyle = {
        ...badgeStyle,
        backgroundColor: "#FEE2E2",
        color: "#991B1B",
        border: "1px solid #FECACA",
      };
    }
  }

  return (
    <div
      className="d-flex align-items-center justify-content-between px-4"
      style={{
        height: "60px",
        borderBottom: "1px solid #E1E1E1",
        background: test?._id === focusedExam ? "#e8e8e8" : "",
      }}
    >
      <div className="practice-set-info d-flex align-items-center gap-3">
        <div
          style={{
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "22px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            color: "#1B2128",
          }}
        >
          {test?.name}
        </div>
        <span className="score-badge" style={badgeStyle}>
          {isUnattempted ? "Unattempted" : isBand && isPending ? 'Pending' : isBand ? `Band: ${score}` : `Score: ${roundScore(score)}%`}
        </span>
      </div>
      <div>{renderTestButton(test, topic, testInd)}</div>
    </div>
  );
};

export default TestItem;
